const styles = {
  gridSx: {
    display: "grid",
    gridTemplateColumns: { xs: "minmax(0, 340px)", sm: "repeat(2, minmax(0, 400px))", md: "repeat(3, minmax(0, 340px))" },
    justifyContent: "center",
    gap: { xs: 2, md: 2 },
    width: "100%",
  },

  buttonWrapperSx: { width: "100%", display: "flex", justifyContent: "center" },

  buttonSx: {
    px: { xs: 5, md: 8 },
    py: { xs: 1.5, md: 2 },
    fontSize: { xs: 14, md: 16 },
    mt: { xs: 5, md: 8 },
    mb: { xs: 6, md: 10 },
  },

  progressSx: { color: "white" },
};

export default styles;
